import React from 'react';
import useVerifyAccess from 'hooks/useVerifyAccess';
import { Redirect, useLocation } from 'react-router-dom';
import { useAuth } from 'context/AuthProvider';
// import BWLoader from 'components/shared/BWLoader';
import logoBaoChau from 'assets/bw_image/logo_baochau.svg';
import styled from 'styled-components';

const DefaultLayout = React.lazy(() => import('../layouts/DefaultLayout'));

const LoadingImage = styled.img`
  display: block;
  width: 180px;
  max-width: 42vw;
  height: auto;
  margin: 0 auto;
`;

const BackgroundLoading = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  background: #ffffff;
`;

const RecoveryPanel = styled.div`
  max-width: 420px;
  margin: 0 auto;
  padding: 24px;
  text-align: center;
  color: #1f2937;

  p {
    margin: 18px 0;
    line-height: 1.5;
  }

  button {
    border: 0;
    border-radius: 6px;
    padding: 10px 18px;
    color: #fff;
    background: #ed3237;
    cursor: pointer;
  }
`;

function VerifyAccess(props) {
  const location = useLocation();
  const { initializing, error, retryInitialization } = useAuth();
  const { verify } = useVerifyAccess(props);

  const _render = () => {
    let _verify = verify(null, location);

    return _verify === true ? (
      <DefaultLayout {...props} />
    ) : false === _verify ? (
      <Redirect to='/login' />
    ) : (
      <DefaultLayout {...props} accessDenied />
    );
  };

  if (initializing) {
    return (
      <BackgroundLoading>
        <LoadingImage src={logoBaoChau} />
      </BackgroundLoading>
    );
  }

  if (error) {
    return (
      <BackgroundLoading>
        <RecoveryPanel>
          <LoadingImage src={logoBaoChau} alt='Bảo Châu Elec' />
          <p>Kết nối tới hệ thống đang tạm thời gián đoạn. Phiên đăng nhập của bạn vẫn được giữ an toàn.</p>
          <button type='button' onClick={retryInitialization}>Thử kết nối lại</button>
        </RecoveryPanel>
      </BackgroundLoading>
    );
  }

  return <React.Fragment>{_render()}</React.Fragment>;
}

export default VerifyAccess;
